export const getGroupSizeRanges = (additionalInputs: string[] | undefined): string[] => {
  return (
    (additionalInputs &&
      additionalInputs
        .flatMap((require) => parseGroupSizeRange(require))
        .filter((range: string | null) => range !== null)) ||
    []
  );
};

export const parseGroupSizeRange = (input: string): string[] | null => {
  const regex = /^GROUP_NUMERIC_SIZE_(\d+-\d+(?:_\d+-\d+)*)$/;

  const matches = input.match(regex);

  if (!matches || matches.length !== 2) {
    return null;
  }
  return matches[1].split('_');
};

export const isGroupSizeInRange = (groupSizeFormValue: string, range: string): boolean => {
  const [minStr, maxStr] = range.split('-');
  const groupSize = parseInt(groupSizeFormValue, 10);
  const min = parseInt(minStr, 10);
  const max = parseInt(maxStr, 10);

  return groupSize >= min && groupSize <= max;
};
